(() => {
  function initOffer(dialog) {
    if (dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
    dialog.dataset.initialized = 'true';
    const editor = dialog.dataset.designMode === 'true';
    const campaign = window.XC_CAMPAIGN_STATE;
    const isMidAutumn = Boolean(campaign?.isMidAutumnActive?.());
    const season = dialog.querySelector('[data-xc-offer-season]');
    const defaultTerms = dialog.querySelector('[data-xc-offer-terms-default]');
    const midAutumnTerms = dialog.querySelector('[data-xc-offer-terms-mid]');
    if (season) season.textContent = isMidAutumn ? '中秋特惠' : '秋季特惠';
    if (defaultTerms) defaultTerms.hidden = isMidAutumn;
    if (midAutumnTerms) midAutumnTerms.hidden = !isMidAutumn;
    dialog.dataset.campaign = isMidAutumn ? 'mid-autumn-2026' : 'autumn-2026';
    const key = 'srh-offer:' + dialog.dataset.campaign;
    const date = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Hong_Kong', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    const seen = () => {
      try { if (localStorage.getItem(key) === date()) return true; } catch (_) {}
      try { if (sessionStorage.getItem(key) === date()) return true; } catch (_) {}
      return false;
    };
    const end = dialog.dataset.end.trim();
    const code = dialog.dataset.code.trim();
    if (!editor && ((end && (!/^\d{4}-\d{2}-\d{2}$/.test(end) || date() > end)) || (dialog.dataset.mode === 'code' && !code) || seen())) return;
    const link = dialog.querySelector('[data-offer-shop]');
    if (dialog.dataset.mode === 'code' && code) {
      link.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dialog.dataset.destination);
    }
    const track = action => {
      if (!editor) (window.dataLayer = window.dataLayer || []).push({ event: 'autumn_offer_' + action, campaign: dialog.dataset.campaign, page_type: 'homepage', offer_mode: dialog.dataset.mode });
    };
    let previousFocus;
    let attempts = 0;
    let timer;
    let previousOverflow;
    let closeReason = 'dismiss';
    const close = () => dialog.close();
    dialog.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
    });
    dialog.addEventListener('close', () => { document.documentElement.style.overflow = previousOverflow; track(closeReason); if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true }); });
    link.addEventListener('click', () => { closeReason = 'click'; close(); });
    const show = () => {
      if (!dialog.isConnected || (!editor && seen())) return;
      const anotherModal = [...document.querySelectorAll('dialog[open], details.menu-opening, cart-drawer.active, [aria-modal="true"]:not(.srh-offer)')].some(element => !element.closest('details:not([open]), [hidden], [aria-hidden="true"]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      if (document.hidden || anotherModal) {
        if (++attempts < 20) timer = setTimeout(show, 750);
        return;
      }
      previousFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      if (!editor) {
        try { localStorage.setItem(key, date()); } catch (_) {}
        try { sessionStorage.setItem(key, date()); } catch (_) {}
      }
      track('view');
    };
    timer = setTimeout(show, editor ? 0 : 700);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(dialog)) { clearTimeout(timer); if (dialog.open) close(); }
    });
  }
  document.querySelectorAll('[data-srh-offer]').forEach(initOffer);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-srh-offer]').forEach(initOffer));
})();
